import {premiumColor} from '../sass/base/_exports.sass';

export const HeartFilledIcon = (props) => {
  const {color = premiumColor, className = '', ratio = 1} = props;

  // default dimensions
  const width = 22;
  const height = 20;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <path
        fill={color}
        d="M51.8,36.115c2.47,4.934-.792,11.274-9.878,16.23l-.407.222-.407-.222c-9.084-4.956-12.346-11.3-9.876-16.23A6,6,0,0,1,41.518,34.88,6,6,0,0,1,51.8,36.115Z"
        transform="translate(-30.437 -32.502)"
      />
    </svg>
  );
};
